import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a126514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-input" }
const _hoisted_2 = ["id", "disabled", "placeholder", "required", "type"]
const _hoisted_3 = {
  key: 0,
  class: "form-info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true"
}, null, -1))

import { Ref, ref, toRefs, watch, withDefaults } from 'vue'

  import PasswordStrength from '@/components/Common/PasswordStength.vue'

  interface Props {
    checkStrength?: boolean
    disabled?: boolean
    id?: string
    password?: string
    placeholder?: string
    required?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    checkStrength: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    id: { default: 'password' },
    password: { default: '' },
    placeholder: null,
    required: { type: Boolean, default: false }
  },
  emits: ['updatePassword', 'passwordError'],
  setup(__props: any, { emit }) {

const props = __props as { checkStrength: boolean, disabled: boolean, id: string, password: string, placeholder?: string, required: boolean }

  
  const { checkStrength, disabled, id, password, placeholder, required } =
    toRefs(props)

  const showPassword: Ref<boolean> = ref(false)
  const passwordValue: Ref<string> = ref('')

  

  function togglePassword() {
    showPassword.value = !showPassword.value
  }
  function updatePassword(event: Event & { target: HTMLInputElement }) {
    emit('updatePassword', event.target.value)
  }
  function invalidPassword() {
    emit('passwordError')
  }

  watch(
    () => password.value,
    (newPassword) => {
      if (newPassword === '') {
        passwordValue.value = ''
      }
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: _unref(id),
      disabled: _unref(disabled),
      placeholder: _unref(placeholder),
      required: _unref(required),
      type: showPassword.value ? 'text' : 'password',
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordValue).value = $event)),
      minlength: "8",
      onInput: updatePassword,
      onInvalid: invalidPassword
    }, null, 40, _hoisted_2), [
      [_vModelDynamic, passwordValue.value]
    ]),
    _createElementVNode("div", {
      class: "show-password",
      onClick: togglePassword
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t(`user.${showPassword.value ? 'HIDE' : 'SHOW'}_PASSWORD`)) + " ", 1),
      _createElementVNode("i", {
        class: _normalizeClass(["fa", `fa-eye${showPassword.value ? '-slash' : ''}`]),
        "aria-hidden": "true"
      }, null, 2)
    ]),
    (_unref(checkStrength))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('user.PASSWORD_INFO')), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(checkStrength))
      ? (_openBlock(), _createBlock(PasswordStrength, {
          key: 1,
          password: passwordValue.value
        }, null, 8, ["password"]))
      : _createCommentVNode("", true)
  ]))
}
}

})